<div class="m-0">
  <dialog-header headerClass="primary" 
                 title="{{'DIALOG.TRANSPORT_PROBLEM.TITLE' | translate}}"
                 hideCloseButton="true">
  </dialog-header>
  
  <div class="pt-8 px-16" fxLayout="column">

    <div class="pb-8" fxLayout="row" fxFlex="90">
      {{'DIALOG.TRANSPORT_PROBLEM.MESSAGE' | translate}}
    </div>

    <div *ngFor="let problem of problems">
      {{ problem | translate }}
    </div>

    <div class="py-8" fxLayout="row" fxLayoutAlign="end center">
      <button class="mr-16"
              mat-raised-button
              [matDialogClose]="false">{{'DIALOG.TRANSPORT_PROBLEM.DECLINE' | translate}}
      </button>
      <button mat-raised-button
              color="accent"
              [matDialogClose]="true"
              cdkFocusInitial>{{'DIALOG.TRANSPORT_PROBLEM.CONFIRM' | translate}}
      </button>
    </div>
  </div>
</div>
